








































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { actionsEvent } from '@/setup';
import { AlertaGrilla } from '@/pantallas/Camaras/Alertas/fetchAlerta';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import { fetchAltaServicio } from './fetchAltaServicio';
//import modalCREARDetalleAltaServicio from '@/pantallas/Conecta/AltasServicio/modal_crear_detalle_alta.vue';
import TablaSeriesTodos from './TablaSeriesTodos.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { getUserId } from '../MantenedorLocalidad/helpers/getUserId';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import config from '@/config/index';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { boolean } from 'yup';
import { AxiosAdapter, AxiosResponse } from 'axios';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    MantenedorGrid,
    DatePicker,
    TablaSeriesTodos,
    MantenedorGridSinCodigo,
    'app-confirmacion': Confirmation,
  },
})
export default class ModalEditarAlta extends Vue {
  @Prop({ required: true, default: {} }) data!: any;
  @Prop({ required: true, default: [] }) filtroCoordinador!: any[];
  @Prop({ required: true, default: [] }) filtroFlota!: any[];
  @Prop({ required: true, default: true }) show: boolean;

  detalle_alta_tecnico: any = [];
  gridApi: GridApi = null;
  gridApi2: GridApi = null;
  columnApi2: ColumnApi = null;
  gridEvent2: GridReadyEvent = null;
  columnDef: ColDef[] = [];
  gridOptions3: GridOptions = null;

  dataList: any = null;
  filterFlotasApi: any[] = [];

  model_filtro_tecnico: any = null;
  Modal_confirmar_TEXTO: any = '';
  modal_tabla: any;
  dictionaryFormErrors: any = {};
  naranja: boolean = false;
  inputError: Record<string, boolean> = {
    coordinador: false,
    flota: false,
  };
  dialogPopUp: boolean = false;
  disabledButtun: boolean = false;

  handleShowPopUp() {
    // Validar que todos los valores del objeto tengan un valor válido
    const hasValue: boolean = Object.values(this.objParam).some(val => !!val);
    if (!hasValue) {
      this.handleCloseModal({});
      return;
    }
    this.dialogPopUp = true;
  }

  showPopuP(confirmation: boolean) {
    this.dialogPopUp = !this.dialogPopUp;
    if (confirmation) {
      this.handleCloseModal({});
    }
  }

  objParam: {
    coorid: string;
    cod_flota: string;
  } = {
    coorid: '',
    cod_flota: '',
  };
  activeteChangeEvent: boolean = false;

  excludeInactiveDataInLists({ list, key }: { list: any[]; key: string }) {
    // Retornar los elemnos donde el elemento 'key' sea diferente de "true"
    return list.filter(x => x[key] !== 't');
  }

  AltaServicioDetalleModalState: boolean = false;

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  cambio_tecnico() {
    //this.modal_tabla.recargar_tecnico();
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }

  async fillFields() {
    const coordinador = await this.filtroCoordinador.find(
      x => x.coorname === this.data['Coordinador']
    );
    const flota = await this.filtroFlota.find(
      x => x['__nom_flota'] === this.data['Flota']
    );
    this.objParam.coorid = coordinador ? coordinador.coorid : '';
    this.objParam.cod_flota = flota ? flota.cod_flota : '';
  }

  mounted() {
    this.getFilters();
    this.fillFields();
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  handleCloseModal({ reload = false }) {
    this.$emit('closeModal', reload);
  }

  handleChangeEvent() {
    if (this.activeteChangeEvent) {
      // Válida que los inputs tengan valor si no es así, activa los errores e inhabilita el botón
      this.inputError.coordinador = this.objParam.coorid ? false : true;
      if (this.filterFlotasApi.length > 0) {
        this.inputError.flota = this.objParam.cod_flota ? false : true;
        this.disabledButtun = Object.values(this.objParam).some(
          val => val === ''
        );
      } else {
        this.disabledButtun = this.objParam.coorid ? false : true;
      }
    }
  }

  handleEdit() {
    if (this.filterFlotasApi.length > 0) {
      const emptyField: boolean = Object.values(this.objParam).every(
        val => !!val
      );
      if (!emptyField) {
        this.activeteChangeEvent = true;
        this.$snotify.error('Todos los campos son obligatorios', {
          timeout: 3000,
        });
        this.handleChangeEvent();
        return;
      }
    }
    if (!this.objParam.coorid) {
      this.activeteChangeEvent = true;
      this.$snotify.error('El campo Coordinador es obligatorio', {
        timeout: 3000,
      });
      this.handleChangeEvent();
      return;
    }
    this.editAlta();
  }

  async getFilters() {
    try {
      this.loadingService.showLoading();
      const result = await fetchAltaServicio(
        {
          tag: 'only_flota_id',
          ...this.data,
        },
        'conecta_altas_servicio/get_filters2'
      );
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, FLOTAS } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.filterFlotasApi = FLOTAS;
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async editAlta() {
    const flota = await this.filtroFlota.find(
      x => x.cod_flota === this.objParam.cod_flota
    );
    const __nom_flota: string = flota ? flota.__nom_flota : '';

    const usuarioid: number = getUserId();
    const clienteDefecto: string = localStorage.getItem('clienteDefecto');
    const { length } = this.filterFlotasApi;

    try {
      this.loadingService.showLoading();
      const result = await fetchAltaServicio(
        {
          num_flotas: length,
          __nom_flota,
          usuarioid,
          clienteDefecto,
          ...this.data,
          ...this.objParam,
        },
        'conecta_altas_servicio/edit_alta'
      );
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
      this.handleCloseModal({ reload: true });
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }
}
